export default "__VITE_ASSET__rCTEaFoQ__"